import React from 'react';

import LogoutSuccessfulFeature from '@features/logout-successful';

function ElearningWpRemoteLogoutSuccessfulPage() {
  return <LogoutSuccessfulFeature />;
}

export default ElearningWpRemoteLogoutSuccessfulPage;
